import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { SelectModule } from 'primeng/select';

import { AuthService } from './auth/auth.service';
import { USER_LANGUAGE_KEY } from './language.constants';

@Component({
  selector: 'app-language',
  standalone: true,
  imports: [SelectModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-select
      test-id="language-selector"
      (onChange)="changeLang($event.value)"
      styleClass="border-0"
      optionLabel="name"
      optionValue="code"
      [options]="languages"
      [(ngModel)]="selectedLanguage"
    >
    </p-select>
  `,
  styles: []
})
export class LanguageComponent implements OnInit {
  selectedLanguage = 'de';
  languages = [
    { name: 'Español', code: 'es' },
    { name: 'English', code: 'en' },
    { name: 'Deutsch', code: 'de' },
    { name: 'Русский', code: 'ru' }
  ];

  translocoService = inject(TranslocoService);
  authService = inject(AuthService);

  ngOnInit() {
    this.selectedLanguage = localStorage.getItem(USER_LANGUAGE_KEY) || this.translocoService.getActiveLang();
  }

  changeLang(language: string) {
    void this.authService.setUserLanguage(language);
  }
}
